var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCdSerIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2938_1059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75 25.875C5.75 23.4969 7.68444 21.5625 10.0625 21.5625C12.4406 21.5625 14.375 23.4969 14.375 25.875H17.25C17.25 25.875 17.25 21.1883 17.25 21.1751C17.25 20.101 18.4875 19.3946 19.414 19.9341C20.3479 20.4779 21.5625 19.7694 21.5625 18.6875C21.5625 17.6434 20.3315 16.901 19.4141 17.4408C18.477 17.9923 17.25 17.2822 17.25 16.1999V8.625H4.3125C1.93444 8.625 0 10.5594 0 12.9375V25.875H5.75Z",
    fill: "#0e131c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 40.25C14.8719 40.25 12.9375 38.3156 12.9375 35.9375C12.9375 33.5594 14.8719 31.625 17.25 31.625V28.75H12.5493C11.477 28.75 10.7507 27.5396 11.309 26.5854C11.8482 25.664 11.1507 24.4376 10.0626 24.4375C9.02151 24.4374 8.27879 25.6705 8.81586 26.5852C9.3679 27.5255 8.66337 28.75 7.57565 28.75H0V41.6875C0 44.0656 1.93444 46 4.3125 46H17.25V40.25Z",
    fill: "#0e131c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.625 28.75C31.625 31.1281 29.6906 33.0625 27.3125 33.0625C24.9344 33.0625 23 31.1281 23 28.75H20.125V33.4499C20.125 34.527 18.8901 35.2331 17.9611 34.6909C17.0326 34.1491 15.8125 34.8542 15.8125 35.9375C15.8125 36.9854 17.0418 37.7251 17.961 37.1841C18.8932 36.6354 20.125 37.3533 20.125 38.4251V46H33.0625C35.4406 46 37.375 44.0656 37.375 41.6875V28.75H31.625Z",
    fill: "#0e131c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6875 0H27.3125C26.518 0 25.875 0.642951 25.875 1.4375V7.57492C25.875 8.6647 27.1002 9.36412 28.0396 8.81594C28.9802 8.26706 30.1875 8.99186 30.1875 10.0625C30.1875 11.1118 28.9604 11.8528 28.0398 11.3092C27.1062 10.7579 25.875 11.4784 25.875 12.55V18.6875C25.875 19.482 26.518 20.125 27.3125 20.125H31.625C31.625 22.5031 33.5594 24.4375 35.9375 24.4375C38.3156 24.4375 40.25 22.5031 40.25 20.125H44.5625C45.357 20.125 46 19.482 46 18.6875V4.3125C46 1.93444 44.0656 0 41.6875 0Z",
    fill: "#B2E1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2938_1059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdSerIcon04);
export default __webpack_public_path__ + "static/media/cd-ser_icon04.2593c47c910460692c2abb914516bb26.svg";
export { ForwardRef as ReactComponent };